import React, { useEffect } from 'react';
import PortfolioGrid from '../components/home/PortfolioGrid.tsx';
import TestimonialsSection from '../components/home/TestimonialsSection.tsx';
import { useApp } from '../context/AppContext.tsx';

export default function PortfolioCatalog() {
  const { settings } = useApp();
  const portfolioSec = settings?.sections?.find((s) => s.type === 'portfolio_grid');
  const pageTitle = portfolioSec?.title || 'Profil Project & Rekam Jejak Unggulan';
  const pageSubtitle = portfolioSec?.subtitle || 'Dokumentasi implementasi proyek nyata, konsultasi keberlanjutan, dan hasil kerja sama strategis dengan mitra.';

  useEffect(() => {
    const customTab = settings?.pageTabTitles?.portfolio?.trim();
    if (customTab) {
      document.title = customTab;
    } else {
      const suffix = settings?.pageTabTitles?.titleSuffix !== undefined ? settings.pageTabTitles.titleSuffix : ` | ${settings?.siteName || ''}`;
      document.title = `${pageTitle}${suffix}`;
    }
  }, [pageTitle, settings?.siteName, settings?.pageTabTitles?.portfolio, settings?.pageTabTitles?.titleSuffix]);

  return (
    <div id="portfolio-catalog-page" className="py-6 space-y-6">
      <PortfolioGrid
        badge={portfolioSec?.badge || 'PROFIL PROJECT'}
        title={pageTitle}
        subtitle={pageSubtitle}
        limit={1}
        isPageMode={true}
      />
      <TestimonialsSection />
    </div>
  );
}

